import { render } from "./ConnectButton.vue?vue&type=template&id=86f7fb70&scoped=true"
import script from "./ConnectButton.vue?vue&type=script&lang=js"
export * from "./ConnectButton.vue?vue&type=script&lang=js"

import "./ConnectButton.vue?vue&type=style&index=0&id=86f7fb70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f7fb70"]])

export default __exports__